import DashboardAttorney from './DashboardAttorney';

export default DashboardAttorney;
